module.exports = "https://cdn.thelire.com/ins/resource/ico_freecoins_5star@2x.b3f1e25983c5d14b3e98d0bce4fd221c.png";